module.exports = __webpack_public_path__ + "static/media/023.d7d22745.jpg";